var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgSearch = function SvgSearch(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 32 32"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M15 3.5C8.649 3.5 3.5 8.649 3.5 15S8.649 26.5 15 26.5a11.45 11.45 0 0 0 7.002-2.377L26 28.121 28.121 26l-3.998-3.998A11.45 11.45 0 0 0 26.5 15c0-6.351-5.149-11.5-11.5-11.5M6.5 15a8.5 8.5 0 1 1 17 0 8.5 8.5 0 0 1-17 0",
    clipRule: "evenodd"
  })));
};
export default SvgSearch;